module.exports = __webpack_public_path__ + "static/media/one-core-documentation.b99cdee5.png";